import { useRouter } from "next/router";
import * as React from "react";
import { cs } from "../../core/classSet";
import { getIndustrySlug } from "../../core/getParam";
import { IIndustry } from "../../typings/filterEntities";
import ExploreIndustriesCard from "../ExploreIndustriesCard/ExploreIndustriesCard";
import Wrapper from "../Wrapper/Wrapper";
import styles from "./ExploreIndustriesGrid.module.css";

interface IProps {
  industries: IIndustry[];
}

export default function ExploreIndustriesGrid({ industries }: IProps) {
  const router = useRouter();
  const industrySlug = getIndustrySlug(router);

  const hasIndustryParam = !!industrySlug && industrySlug !== "all";

  const otherIndustries = React.useMemo(
    () => industries.filter((i) => i.slug !== industrySlug) ?? [],
    [industries, industrySlug],
  );

  if (!otherIndustries.length) {
    return null;
  }

  return (
    <aside className={styles.root}>
      <Wrapper>
        <h3 className={styles.heading}>
          {hasIndustryParam ? "Explore other industries" : "Explore by industry"}
        </h3>
        <ul className={cs(styles.grid, otherIndustries.length < 9 && styles.gridSelected)}>
          {otherIndustries.map((i) => (
            <li className={styles.gridItem} key={i.slug}>
              <ExploreIndustriesCard industry={i} large={otherIndustries.length < 9} />
            </li>
          ))}
        </ul>
      </Wrapper>
    </aside>
  );
}
